module.exports = __webpack_public_path__ + "img/2.ad498820.svg";